var map = {
	"./angpao.webp": 2333,
	"./bonus.webp": 2334,
	"./gpi-rebate-m.webp": 2335,
	"./gpi-rebate.webp": 2336,
	"./hublot-watch-2018.webp": 2337,
	"./hublot-watch-2022.webp": 2338,
	"./iphone-13-pro-max.webp": 2339,
	"./iphone-14-pro-max.webp": 2340,
	"./login-to-m.webp": 2341,
	"./login-to.webp": 2342,
	"./mb.webp": 2343,
	"./mg-rebate-m.webp": 2344,
	"./mg-rebate.webp": 2345,
	"./np.webp": 2346,
	"./pointer.webp": 2347,
	"./pp-rebate-m.webp": 2348,
	"./pp-rebate.webp": 2349,
	"./sadface.webp": 2350,
	"./wallet-m.webp": 2351,
	"./wallet.webp": 2352,
	"./wheel-b.webp": 2353,
	"./wheel-btn.webp": 2354,
	"./wheel-indon-b.webp": 2355,
	"./wheel-indon.webp": 2356,
	"./wheel.webp": 2357
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 937;